import { extractWidthAndHeight as a } from "../../../utilities/index.js";
const p = (e) => ({
  variant: "playable",
  embedId: e.properties?.playable_id,
  allow: "autoplay; fullscreen"
}), l = (e) => ({
  variant: "datawrapper",
  embedId: e.properties?.data_wrapper_id
}), d = (e) => {
  const { width: r, height: t } = a(e.properties?.styleAttribute || "");
  return {
    variant: "basic",
    src: e.properties?.url,
    title: e.properties?.idAttribute,
    width: r,
    height: t
  };
};
export {
  l as embedDataWrapperDeliveryApiParser,
  d as embedDeliveryApiParser,
  p as embedPlayableDeliveryApiParser
};
